// Index of language folders for FamilyWall for i18n plugin of requireJS
import root from "./root/familywall.js?amd";
import fr from "./fr/familywall.js?amd";
import es from "./es/familywall.js?amd";
import de from "./de/familywall.js?amd";
import pt from "./pt/familywall.js?amd";
import sq from "./sq/familywall.js?amd";
import it from "./it/familywall.js?amd";
import nl from "./nl/familywall.js?amd";
import ja from "./ja/familywall.js?amd";
import ru from "./ru/familywall.js?amd";

export default {
    // English is defined as "root" to be used as fallback
    "root": root,
   
      // Set a property to true for each language
    // in which familywall.js is available
    "fr": fr,
    "es": es,
    "de": de,
    "pt": pt,
    "sq": sq,
    "nl": nl,
    "it":it,
    "ja":ja,
    "ru":ru
    
  }

